<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <base-v-component
      heading="Customers"
      link="components/simple-tables"
    />

    <base-material-card
      icon="mdi-clipboard-text"
      title="Customers"
      class="px-5 py-3"
    >
      <div class="d-flex justify-end">
        <v-col
          class="d-flex align-self-end"
          cols="12"
          sm="2"
        >
          <v-select
            v-model="selectedType"
            :items="types"
            label="Department"
            item-text="name"
            item-value="value"
            outlined
            @change="changeSystem"
          />
        </v-col>
      </div>
      <h2
        v-if="selectedType=='finish-analytics' || selectedType=='all'"
      >
        Finish
      </h2>
      <div
        v-if="selectedType=='finish-analytics' || selectedType=='all'"
      >
        <div class="row">
          <h4 class="my-5 pl-3 primary--text">Account Manager</h4>
        </div>

        <section class="row">
          <div
            v-for="(value,acctmgr) in finishCustomers"
            :key="acctmgr"
            class="col-12"
          >
              <h3
                v-if="acctmgr!=''"
              >
                {{ acctmgr }}
              </h3>
              <table
                v-if="acctmgr!=''"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="primary--text">
                      <p>Year</p>
                    </th>
                    <th class="primary--text">
                      <p>Month</p>
                    </th>
                    <th class="primary--text">
                      <p>Count</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record,index) in value"
                    :key="index"
                    class="text-center"
                  >
                    <td>{{ record.YR }}</td>
                    <td>{{ record.MNTH }}</td>
                    <td>{{ record.CNT }}</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </section>
      </div>
      <h2
        v-if="selectedType=='aqua-analytics' || selectedType=='all'"
      >
        Aqua
      </h2>
      <div
        v-if="selectedType=='aqua-analytics' || selectedType=='all'"
      >
        <div class="row">
          <h4 class="my-5 pl-3 primary--text">Account Manager</h4>
        </div>

        <section class="row">
          <div
            v-for="(value,acctmgr) in aquaCustomers"
            :key="acctmgr"
            class="col-md-12"
          >
              <h3
                v-if="acctmgr!=''"
              >
                {{ acctmgr }}
              </h3>
              <table
                v-if="acctmgr!=''"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="primary--text">
                      <p>Year</p>
                    </th>
                    <th class="primary--text">
                      <p>Month</p>
                    </th>
                    <th class="primary--text">
                      <p>Count</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record,index) in value"
                    :key="index"
                    class="text-center"
                  >
                    <td>{{ record.YR }}</td>
                    <td>{{ record.MNTH }}</td>
                    <td>{{ record.CNT }}</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </section>
      </div>
      <h2
        v-if="selectedType=='metal-analytics' || selectedType=='all'"
      >
        Metal
      </h2>
      <div
        v-if="selectedType=='metal-analytics' || selectedType=='all'"
      >
        <div class="row">
          <h4 class="my-5 pl-3 primary--text">Account Manager</h4>
        </div>

        <section class="row">
          <div
            v-for="(value,acctmgr) in metalCustomers"
            :key="acctmgr"
            class="col-12"
          >
              <h3
                v-if="acctmgr!=''"
              >
                {{ acctmgr }}
              </h3>
              <table
                v-if="acctmgr!=''"
                style="width:100%"
              >
                <thead>
                  <tr>
                   <th class="primary--text">
                      <p>Year</p>
                    </th>
                    <th class="primary--text">
                      <p>Month</p>
                    </th>
                    <th class="primary--text">
                      <p>Count</p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(record,index) in value"
                    :key="index"
                    class="text-center"
                  >
                    <td>{{ record.YR }}</td>
                    <td>{{ record.MNTH }}</td>
                    <td>{{ record.CNT }}</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </section>
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
  import Axios from 'axios'
  import { constants } from '../../../constants'
  export default {
    name: 'DashboardPagesTimeline',
    data: () => ({
      selectedType: 'finish-analytics',
      types: [{ name: 'Finish', value: 'finish-analytics' }, { name: 'Aqua', value: 'aqua-analytics' }, { name: 'Metal', value: 'metal-analytics' }, { name: 'All', value: 'all' }],
      headers: [
        {
          text: 'Line',
          align: 'start',
          value: 'line',
          groupable: false,
        },
        { text: 'Account Manager', value: 'acctmgr', align: 'right' },
        { text: 'Line', value: 'line', align: 'right' },
        { text: 'Month', value: 'MNTH', align: 'right' },
        { text: 'Year', value: 'YR', align: 'right' },
        { text: 'Count', value: 'CNT', align: 'right' },
      ],
      menu: false,
      finishCustomers: [],
      aquaCustomers: [],
      metalCustomers: [],
    }),
    created () {
      Axios.get(constants.VUE_APP_BASEURL + '/customers?type=finish-analytics').then(res => {
        this.finishCustomers = res.data.customers.reduce(function (r, a) {
          r[a.acctmgr] = r[a.acctmgr] || []
          r[a.acctmgr].push(a)
          return r
        }, Object.create(null))
      })
    },
    methods: {
      changeSystem (a) {
        Axios.get(constants.VUE_APP_BASEURL + '/customers?type=' + a).then(res => {
          if (a === 'all') {
            this.finishCustomers = res.data.customers.filter(customer => customer.line === 'finish-analytics')
            this.finishCustomers = this.finishCustomers.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.aquaCustomers = res.data.customers.filter(customer => customer.line === 'aqua-analytics')
            this.aquaCustomers = this.aquaCustomers.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.metalCustomers = res.data.customers.filter(customer => customer.line === 'metal-analytics')
            this.metalCustomers = this.metalCustomers.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
          } else if (a === 'finish-analytics') {
            this.finishCustomers = res.data.customers.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.metalustomers = []
            this.aquaCustomers = []
          } else if (a === 'metal-analytics') {
            this.metalCustomers = res.data.customers.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.finishCustomers = []
            this.aquaCustomers = []
          } else if (a === 'aqua-analytics') {
            this.aquaCustomers = res.data.customers.reduce(function (r, a) {
              r[a.acctmgr] = r[a.acctmgr] || []
              r[a.acctmgr].push(a)
              return r
            }, Object.create(null))
            this.finishCustomers = []
            this.metalCustomers = []
          }
        })
      },
    },
  }

</script>
<style>
 tr:nth-child(even) {
    background: #eee;
}
th.primary--text {
    font-size: 16px !important;
}

th.primary--text p {
    font-size: 0.90rem;
}
</style>
